<template>
    <div class="agent-page">
        <div style="display: flex; flex-direction: column; text-align: start;">
            <div style="display: flex; align-items: center; justify-content: space-between;">
                <h2 class="page-title" >半流程--发布招标公告</h2>
                <div>
                    <!-- <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button> -->
                    <el-button type="primary" icon="el-icon-plus" @click="handleAddChange">发布变更公告</el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="handleAddNew">新增招标公告</el-button>
                
                </div>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="announcementName" label="公告名称" show-overflow-tooltip />
                <el-table-column prop="announcementCode" label="公告编码" show-overflow-tooltip />
                <el-table-column prop="releaseDate" label="发布日期" width="180" align="center" />
                <el-table-column prop="announcementNature" label="公告性质" show-overflow-tooltip />
                <el-table-column prop="announcementType" label="公告类型" show-overflow-tooltip />
                <el-table-column prop="releaseStatus" label="发布状态" show-overflow-tooltip />
                <el-table-column label="详细信息" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleViewDetail(scope.row)" class="action-btn">
                            详情
                        </el-button>
                        <el-button type="text" size="small" @click="handleEdit(scope.row)" class="action-btn">
                            编辑
                        </el-button>
                        <el-button type="text" size="small" @click="handleDelete(scope.row)"
                            class="action-btn delete-btn">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 详情弹窗 -->
        <el-dialog
            title="招标公告详情"
            :visible.sync="detailDialogVisible"
            width="50%"
            :close-on-click-modal="false"
            :append-to-body="true"
            class="detail-dialog">
            <div class="detail-content">
                <el-row :gutter="20">
                    <!-- 左列 -->
                    <el-col :span="12">
                        <div class="detail-item">
                            <span class="detail-label">公告名称:</span>
                            <span class="detail-value">中山大厦项目招标公告</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">公告发布时间:</span>
                            <span class="detail-value">2025-09-17 16:25:39</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">响应文件递交方法:</span>
                            <span class="detail-value">网上递交</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">文件获取时间范围:</span>
                            <span class="detail-value">投标人只能在公告发布期内下载文件</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">是否涉密(发布信息是否包含国家秘密、工作秘密或涉密敏感信息):</span>
                            <span class="detail-value">不包含</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">公告内容文本:</span>
                            <div class="detail-content-text">
                                123
                            </div>
                        </div>
                    </el-col>

                    <!-- 右列 -->
                    <el-col :span="12">
                        <div class="detail-item">
                            <span class="detail-label">关联标段:</span>
                            <span class="detail-value">中山大厦项目</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">公告结束时间:</span>
                            <span class="detail-value">2025-09-20 00:00:00</span>
                        </div>
                        <div class="detail-item">
                            <span class="detail-label">响应文件递交截止时间:</span>
                            <span class="detail-value">2025-09-30 00:00:00</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            loading: false,
            tableData: [
                {
                    no: 1,
                    announcementName: '中山大厦项目招标公告',
                    announcementCode: 'ZC1101050893002128001',
                    releaseDate: '2025-09-17 16:25:39',
                    announcementNature: '正常公告',
                    announcementType: '招标公告',
                    releaseStatus: '省平台审核通过'
                }
            ],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 1
            },
            detailDialogVisible: false
        }
    },
    methods: {
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },

        // 发布变更公告
        handleAddChange() {
            this.handleAddNew('new_change')
        },

        // 新增邀请书
        handleAddNew(vl) {
            this.$router.push({ path: '/agentHome/semiProcessChild', query: { type: vl } })
        },

        // 查看详情
        handleViewDetail(row) {
            this.detailDialogVisible = true
        },

        // 编辑
        handleEdit(row) {
            this.handleAddNew('edit')
        },

        // 删除
        handleDelete(row) {
            this.$confirm('确定要删除该招标公告吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 这里调用删除接口
                this.$message.success('删除成功')
                this.loadData()
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },

        // 分页相关方法
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },

        // 加载数据
        loadData() {
            this.loading = true
            // 这里调用接口加载数据
            setTimeout(() => {
                this.loading = false
            }, 500)
        }
    },

    mounted() {
        this.loadData()
    }
}
</script>

<style lang="less" scoped>
.agent-page {
    padding: 0;
    background-color: transparent;
    min-height: calc(100vh - 64px);

    .page-title {
        font-size: 22px;
        font-weight: 600;
        color: #303133;
        margin: 0;
        position: relative;
        padding-left: 12px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 20px;
            background: #409EFF;
            border-radius: 2px;
        }
    }

    /deep/ .el-button {
        border-radius: 4px;
        font-weight: 500;
        transition: all 0.3s ease;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

.table-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    margin-top: 20px;
    transition: box-shadow 0.3s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    /deep/ .el-table {
        border-radius: 4px;
        overflow: hidden;

        th {
            background: #f5f7fa;
            color: #606266;
            font-weight: 600;
            font-size: 14px;
            padding: 14px 0;
        }

        td {
            padding: 14px 0;
            font-size: 14px;
            color: #606266;
        }

        .el-table__row {
            transition: background-color 0.2s ease;

            &:hover {
                background-color: #f5f7fa;
            }
        }

        .el-button--text {
            padding: 4px 8px;
            font-size: 14px;
            font-weight: 500;
            transition: all 0.2s ease;

            &:hover {
                background: rgba(64, 158, 255, 0.1);
                border-radius: 4px;
            }
        }
    }
}

.action-btn {
    color: #409EFF;
    margin-right: 10px;
}

.delete-btn {
    color: #F56C6C !important;
}

.pagination-section {
    margin-top: 20px;
    padding: 16px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    display: flex;
    justify-content: flex-end;

    /deep/ .el-pagination {
        .el-pagination__total,
        .el-pagination__jump {
            color: #606266;
            font-weight: 500;
        }

        .btn-prev,
        .btn-next,
        .el-pager li {
            background: transparent;
            border-radius: 4px;
            transition: all 0.2s ease;
            font-weight: 500;

            &:hover {
                background: #f5f7fa;
            }

            &.active {
                background: #409EFF;
                color: #fff;
            }
        }
    }
}

// 详情弹窗样式
.detail-dialog {
    .el-dialog__body {
        padding: 20px;
    }
    
    .detail-content {
        .detail-item {
            display: flex;
            margin-bottom: 15px;
            align-items: flex-start;
            
            .detail-label {
                color: #666;
                font-weight: 500;
                min-width: 200px;
                flex-shrink: 0;
                margin-right: 10px;
                text-align: right;
            }
            
            .detail-value {
                color: #333;
                flex: 1;
                word-break: break-all;
            }
            
            .detail-content-text {
                flex: 1;
                margin-top: 5px;
            }
        }
    }
    
    .dialog-footer {
        text-align: center;
        padding: 10px 0;
    }
}
</style>
